(function ($) {
    $(document).ready(function () {
        const $header_height = $('header').outerHeight();

        // Scroll to ID (not tabs)
        $('a[href*="#"]')
            .not('[href="#"]')
            .not('[href="#0"]')
            .not('.info-tabs-item')
            .on("click", function (e) {
                e.preventDefault();
                const href = $(this).attr("href");
                const urlParts = href.split("#");
                const targetPage = urlParts[0];
                const targetId = "#" + urlParts[1];

                if (window.location.pathname === targetPage || targetPage === "") {
                    scrollToSection(targetId);
                } else {
                    window.location.href = href;
                }
            });

        function scrollToSection(hash) {
            const $target = $(hash);
            if ($target.length) {
                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: $target.offset().top - $header_height
                    }, 1000);
                }, 500);
            }
        }

        // if we have hash on page load
        if (window.location.hash) {
            if (window.location.hash.indexOf("tab-") !== -1) {
                openTabFromHash(window.location.hash);
            } else {
                scrollToSection(window.location.hash);
            }
        }

        // Functional for tabs with scroll to parent container
        function openTabFromHash(hash) {
             let $tabLink = $('a.info-tabs-item[href="' + hash + '"]');
            if ($tabLink.length) {
                $tabLink.trigger('click');

                let $parentSection = $tabLink.closest('.section-information-box');
                if ($parentSection.length) {
                    setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: $parentSection.offset().top - $header_height
                        }, 1000);
                    }, 500);
                } else {

                    setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: $tabLink.offset().top - $header_height
                        }, 1000);
                    }, 500);
                }
            }
        }

        // Change hash for tabs
        $(window).on('hashchange', function () {
            if (window.location.hash.indexOf("tab-") !== -1) {
                openTabFromHash(window.location.hash);
            }
        });

        // Renew URL on tab change
        $('.info-tabs-item').on('shown.bs.tab', function (e) {
            history.pushState(null, null, $(this).attr('href'));
        });
    });
})(jQuery);
